import { motion } from "framer-motion";

const SectionHeading = ({ overline, title, subtitle, align = "center", light = false }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.75, ease: [0.22, 1, 0.36, 1] }}
    className={`mb-10 sm:mb-14 ${align === "center" ? "text-center mx-auto" : ""} max-w-3xl`}
  >
    {overline && (
      <p className={`text-xs font-mono uppercase tracking-[0.2em] font-semibold mb-3 ${light ? "text-[#D99B26]" : "text-[#C28519]"}`} data-testid="section-overline">
        {overline}
      </p>
    )}
    <h2 className={`font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-balance ${light ? "text-[#FAF7F2]" : "text-[#0F2F24]"}`}>
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-4 text-base sm:text-lg leading-relaxed ${light ? "text-[#FAF7F2]/75" : "text-slate-600"}`}>{subtitle}</p>
    )}
  </motion.div>
);

export default SectionHeading;
